import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { Project } from '@/types/project';

async function fetchProject(projectId: string): Promise<Project> {
  console.log('[useProject] Fetching project:', projectId);
  const response = await api.get<{ data: Project }>(`/projects/${projectId}`);
  console.log('[useProject] Response:', response.data);
  return response.data.data;
}

export function useProject(projectId: string | undefined) {
  return useQuery({
    queryKey: ['project', projectId],
    queryFn: () => fetchProject(projectId!),
    enabled: !!projectId,
  });
}
